import React from 'react';
import { MdEmail, MdPhone, MdLocationOn, MdArrowForward } from 'react-icons/md';
import LogoFooter from '../images/LogoFotter.png';
import {
  GiWatermelon,
  GiPineapple,
  GiStrawberry,
  GiOrangeSlice,
  GiGrapes,
  GiKiwiFruit,
  GiShinyApple
} from 'react-icons/gi';
import { FaInstagram, FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-white text-gray-800 pt-16 pb-40 lg:pb-32 mt-16 border-t border-gray-100 relative overflow-hidden">

      {/* Wavy Theme Lines (#FF410B Orange & #0284c7 Blue) at the Bottom */}
      <div className="absolute bottom-0 left-0 right-0 w-full overflow-hidden leading-none pointer-events-none z-0 opacity-80">
        <svg
          className="relative block w-full h-32 sm:h-40 lg:h-48"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          {/* Electric Blue Wave */}
          <path
            d="M0,20 C180,90 380,-20 580,50 C780,120 980,10 1200,60 L1200,120 L0,120 Z"
            fill="rgba(2, 132, 199, 0.15)"
          ></path>
          {/* Brand Orange (#FF410B) Wave */}
          <path
            d="M0,40 C220,110 420,10 620,80 C820,130 1020,30 1200,90 L1200,120 L0,120 Z"
            fill="rgba(255, 65, 11, 0.15)"
          ></path>
          {/* Decorative Dotted Wavy Line */}
          <path
            d="M0,30 Q300,110 600,40 T1200,50"
            fill="none"
            stroke="url(#themeGradient)"
            strokeWidth="3"
            strokeDasharray="8 6"
            className="opacity-100"
          ></path>
          <defs>
            <linearGradient id="themeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="100%" stopColor="#FF410B" />
              <stop offset="50%" stopColor="#0284c7" />
              <stop offset="100%" stopColor="#FF410B" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* Vector Fruit Doodles */}
      <div className="absolute bottom-4 left-4 sm:left-12 flex items-end space-x-3 pointer-events-none z-10">
        <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-[#ffedd5] border border-[#fed7aa] text-[#FF410B] flex items-center justify-center shadow-md transform -rotate-12">
          <GiWatermelon className="text-3xl sm:text-4xl" />
        </div>
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-[#e0f2fe] border border-[#bae6fd] text-[#0284c7] flex items-center justify-center shadow-sm transform rotate-12 -translate-y-2">
          <GiPineapple className="text-2xl sm:text-3xl" />
        </div>
      </div>

      <div className="absolute bottom-4 right-4 sm:right-12 flex items-end space-x-3 pointer-events-none z-10">
        <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-[#e0f2fe] border border-[#bae6fd] text-[#0284c7] flex items-center justify-center shadow-sm transform -rotate-12 -translate-y-2">
          <GiGrapes className="text-2xl sm:text-3xl" />
        </div>
        <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-2xl bg-[#ffedd5] border border-[#fed7aa] text-[#FF410B] flex items-center justify-center shadow-md transform rotate-12">
          <GiOrangeSlice className="text-3xl sm:text-4xl" />
        </div>
      </div>

      <div className="hidden lg:flex absolute bottom-5 left-1/2 -translate-x-1/2 items-end space-x-5 pointer-events-none z-10">
        <div className="w-12 h-12 rounded-xl bg-[#ffedd5] border border-[#fed7aa] text-[#FF410B] flex items-center justify-center shadow-sm transform -rotate-12">
          <GiStrawberry className="text-2xl" />
        </div>
        <div className="w-12 h-12 rounded-xl bg-[#e0f2fe] border border-[#bae6fd] text-[#0284c7] flex items-center justify-center shadow-sm transform rotate-12 -translate-y-2">
          <GiKiwiFruit className="text-2xl" />
        </div>
        <div className="w-12 h-12 rounded-xl bg-[#ffedd5] border border-[#fed7aa] text-[#FF410B] flex items-center justify-center shadow-sm transform -rotate-6">
          <GiShinyApple className="text-2xl" />
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 pb-14 border-b border-gray-200/80">

          {/* Column 1: Brand & Tagline */}
          <div className="space-y-4 lg:col-span-1">
            <Link to="/" className="inline-block transition-transform hover:scale-105">
              <img className="h-12 w-auto object-contain" src={LogoFooter} alt="Falhari Logo" />
            </Link>
            <p className="text-xs text-gray-600 leading-relaxed font-normal">
              <span className="font-semibold text-[#FF410B]">Think Fruits #GoFalhari.</span> Handcrafted fruit salads, fresh juices, and nutritious snacks delivered fresh to your doorstep.
            </p>

            {/* Social Links */}
            <div className="flex space-x-2.5 pt-1">
              <a
                href="https://www.instagram.com/gofalhari/?hl=en"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full bg-slate-100 hover:bg-[#FF410B] text-gray-700 hover:text-white flex items-center justify-center shadow-xs hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5"
              >
                <FaInstagram className="text-base" />
              </a>
              <a
                href="https://www.facebook.com/falhari"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
                className="w-9 h-9 rounded-full bg-slate-100 hover:bg-[#FF410B] text-gray-700 hover:text-white flex items-center justify-center shadow-xs hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5"
              >
                <FaFacebookF className="text-base" />
              </a>
              <a
                href="https://in.linkedin.com/company/falhari"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="LinkedIn"
                className="w-9 h-9 rounded-full bg-slate-100 hover:bg-[#FF410B] text-gray-700 hover:text-white flex items-center justify-center shadow-xs hover:shadow-md transition-all duration-300 transform hover:-translate-y-0.5"
              >
                <FaLinkedinIn className="text-base" />
              </a>
            </div>
          </div>

          {/* Column 2: Explore */}
          <div>
            <h3 className="text-xs font-black text-[#FF410B] uppercase tracking-widest mb-4">
              Explore
            </h3>
            <ul className="space-y-2.5 text-xs sm:text-sm font-medium">
              <li>
                <Link to="/" className="text-gray-700 hover:text-[#FF410B] transition-colors flex items-center gap-1.5 group">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF410B] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/corporate" className="text-gray-700 hover:text-[#FF410B] transition-colors flex items-center gap-1.5 group">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF410B] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Corporate Orders
                </Link>
              </li>
              <li>
                <Link to="/blogs" className="text-gray-700 hover:text-[#FF410B] transition-colors flex items-center gap-1.5 group">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF410B] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Blogs & Articles
                </Link>
              </li>
              <li>
                <Link to="/contactus" className="text-gray-700 hover:text-[#FF410B] transition-colors flex items-center gap-1.5 group">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF410B] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 3: Policies (Separated into dedicated column) */}
          <div>
            <h3 className="text-xs font-black text-[#FF410B] uppercase tracking-widest mb-4">
              Policies
            </h3>
            <ul className="space-y-2.5 text-xs sm:text-sm font-medium">
              <li>
                <Link to="/terms-conditions" className="text-gray-700 hover:text-[#FF410B] transition-colors flex items-center gap-1.5 group">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF410B] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-gray-700 hover:text-[#FF410B] transition-colors flex items-center gap-1.5 group">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF410B] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/refund-policy" className="text-gray-700 hover:text-[#FF410B] transition-colors flex items-center gap-1.5 group">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF410B] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Refund Policy
                </Link>
              </li>
              <li>
                <Link to="/cancellation-policy" className="text-gray-700 hover:text-[#FF410B] transition-colors flex items-center gap-1.5 group">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#FF410B] opacity-0 group-hover:opacity-100 transition-opacity"></span>
                  Cancellation Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Us */}
          <div>
            <h3 className="text-xs font-black text-[#FF410B] uppercase tracking-widest mb-4">
              Get in Touch
            </h3>
            <ul className="space-y-2.5 text-xs">
              <li className="flex items-start gap-2.5 p-2 rounded-xl bg-slate-50 border border-slate-100 hover:border-[#FF410B]/30 transition-all">
                <MdLocationOn className="text-[#FF410B] text-lg flex-shrink-0 mt-0.5" />
                <span className="text-gray-600 text-xs leading-relaxed font-medium">
                  Sector 43, Gurgaon - 122002, Haryana, INDIA
                </span>
              </li>
              <li className="flex items-center gap-2.5 p-2 rounded-xl bg-slate-50 border border-slate-100 hover:border-[#FF410B]/30 transition-all">
                <MdEmail className="text-[#FF410B] text-lg flex-shrink-0" />
                <a href="mailto:hello@falhari.com" className="text-gray-700 text-xs font-semibold hover:text-[#FF410B] transition">
                  hello@falhari.com
                </a>
              </li>
              <li className="flex items-center gap-2.5 p-2 rounded-xl bg-slate-50 border border-slate-100 hover:border-[#FF410B]/30 transition-all">
                <MdPhone className="text-[#FF410B] text-lg flex-shrink-0" />
                <a href="tel:9810387325" className="text-gray-700 text-xs font-semibold hover:text-[#FF410B] transition">
                  +91 9810387325
                </a>
              </li>
            </ul>
          </div>

          {/* Column 5: Order Online Banner Card */}
          <div>
            <div className="p-5 rounded-2xl bg-slate-50 border border-slate-200/60 shadow-xs hover:shadow-md transition-shadow relative">
              <span className="text-xs font-bold text-[#FF410B] uppercase tracking-wider block mb-1">
                Order Online
              </span>
              <h4 className="text-sm font-extrabold text-gray-900 mb-1.5">
                Fresh Fruits at Your Doorstep
              </h4>
              <p className="text-xs text-gray-600 mb-3.5 leading-relaxed">
                Order directly from our official portal for instant delivery & offers.
              </p>
              <a
                href="https://falhari.order.food-pe.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-1.5 w-full py-2 px-3 bg-theme hover:bg-[#e03709] text-white font-bold text-xs rounded-full shadow-xs transition-all transform hover:-translate-y-0.5 whitespace-nowrap"
              >
                <span className="whitespace-nowrap">Order Now</span>
                <MdArrowForward className="text-sm shrink-0" />
              </a>
            </div>
          </div>

        </div>

        {/* Elevated Bottom Copyright & Legal Bar */}
        <div className="pt-8 pb-4 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600 space-y-4 md:space-y-0 font-medium">
          <p>© {new Date().getFullYear()} <span className="font-bold text-gray-800">Falhari</span>. All rights reserved.</p>
          <div className="flex flex-wrap gap-4 sm:gap-6 justify-center md:justify-end text-xs">
            <Link to="/terms-conditions" className="hover:text-[#FF410B] transition">Terms & Conditions</Link>
            <Link to="/privacy-policy" className="hover:text-[#FF410B] transition">Privacy Policy</Link>
            <Link to="/refund-policy" className="hover:text-[#FF410B] transition">Refund Policy</Link>
            <Link to="/cancellation-policy" className="hover:text-[#FF410B] transition">Cancellation Policy</Link>
            <Link to="/contactus" className="hover:text-[#FF410B] transition">Contact Us</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
